var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVhs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08485 10.1818C8.37204 10.1818 7.81212 10.7417 7.81212 11.4545C7.81212 12.1672 8.37204 12.7273 9.08485 12.7273C9.79766 12.7273 10.3576 12.1672 10.3576 11.4545C10.3576 10.7417 9.79766 10.1818 9.08485 10.1818ZM16.7212 7.63636C14.6084 7.63636 12.903 9.34182 12.903 11.4545C12.903 13.5672 14.6084 15.2727 16.7212 15.2727C18.834 15.2727 20.5394 13.5672 20.5394 11.4545C20.5394 9.34182 18.834 7.63636 16.7212 7.63636ZM32.1697 0H1.27273C0.559915 0 0 0.559915 0 1.27273V22.9091H33.4424V1.27273C33.4424 0.559915 32.8825 0 32.1697 0ZM28.2667 14C28.2667 14.7126 27.7068 15.2727 26.9939 15.2727C26.2811 15.2727 25.7212 15.8326 25.7212 16.5455C25.7212 17.2581 25.1613 17.8182 24.4485 17.8182H8.99394C8.28113 17.8182 7.72121 17.2581 7.72121 16.5455C7.72121 15.8326 7.1613 15.2727 6.44848 15.2727C5.73567 15.2727 5.17576 14.7126 5.17576 14V8.90909C5.17576 8.19628 5.73567 7.63636 6.44848 7.63636C7.1613 7.63636 7.72121 7.07628 7.72121 6.36364C7.72121 5.65082 8.28113 5.09091 8.99394 5.09091H24.4485C25.1613 5.09091 25.7212 5.65082 25.7212 6.36364C25.7212 7.07628 26.2811 7.63636 26.9939 7.63636C27.7068 7.63636 28.2667 8.19628 28.2667 8.90909V14ZM24.3576 10.1818C23.6448 10.1818 23.0848 10.7417 23.0848 11.4545C23.0848 12.1672 23.6448 12.7273 24.3576 12.7273C25.0704 12.7273 25.6303 12.1672 25.6303 11.4545C25.6303 10.7417 25.0704 10.1818 24.3576 10.1818Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.7212,
    y1: 22.9091,
    x2: 16.7212,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DA1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA2FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhs);
export default __webpack_public_path__ + "static/media/vhs.33fd1073401c1d57e600a6aee33b9732.svg";
export { ForwardRef as ReactComponent };